/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import { FontSizes, FontWeights, getTheme, IconButton } from "@fluentui/react";
import React from "react";
const theme = getTheme();
export const ShowTeamsHelp = (): JSX.Element => {
    return <div style={{ fontWeight: FontWeights.regular, fontSize: FontSizes.smallPlus, color: theme.palette.neutralPrimary }}>
        <h3>Send to specific Teams Tags or Teams Users </h3>

        <p> When you select Copy To Teams list with Teams that you have access. You can navigate on standard shared or private channels.</p>
        <p>For each channel you select you can also navigate into its document library and find the exact location you want to save your email.</p>


        <div style={{ textAlign: 'center' }}>
            <img width='200' src={require('../../../assets/7.png')} />
        </div>
        <p>
            if you select this button <IconButton
                iconProps={{ iconName: 'share' }}
                title="See The Documents Into The Folder"
                ariaLabel="See The Documents Into The Folder"
                disabled={false}
                checked={false}
                styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}

            /> you will find all your files inside the files of the channel.
        </p>
        <p>
            if you select this button <IconButton
                iconProps={{ iconName: 'Tag' }}
                title="Send Email To Channel Tags"
                ariaLabel="Send Email To Channel Tags"
                disabled={false}
                checked={false}
                styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { height: 20, width: 20, backgroundColor: '#FFD09B', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
            /> open a panel where you can find all defined tags of the selected Team. Select any of this to send the email with its attachments
        </p>

        <p>
            if you select this button <IconButton
                iconProps={{ iconName: 'People' }}
                title="Send Email To Specific Persons"
                ariaLabel="Send Email To Specific Persons"
                disabled={false}
                checked={false}
                styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { height: 20, width: 20, backgroundColor: '#C1E2A4', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
            /> you can select specific users
        </p>
        <p>You can select all the users of tags or just some of them.
            <div style={{ textAlign: 'center' }}>
                <img width='200' src={require('../../../assets/8.png')} />
            </div>
        </p>

    </div>;
};
